import {getElement, removeActive, toggleClass} from "./helpers.js";



function toggleItem(){
    if (!getElement('.toggle-item', true)) return;
    toggleClass('.toggle-item');
}

// function radioButtonItem(){
//     if (!getElement('.radio', true)) return;
//     getElement('.radio', true).forEach(item =>{
//         item.querySelectorAll('.radio__item').forEach(itemRadio => {
//             itemRadio.addEventListener('click', () => {
//                 if (item.dataset.payment){
//                     console.log(itemRadio)
//                 } else {
//                     console.log(item)
//                 }
//                 removeActive(item.querySelectorAll('.radio__item'));
//                 itemRadio.classList.add('active')
//
//             });
//
//
//         })
//     })
//
// }
export default function logicElements(){
    toggleItem();

}
export  {toggleItem};